import { customAlphabet } from 'nanoid';
import type { Tagged } from 'type-fest';
import { v4 as uuidV4, v7 as uuidV7, validate } from 'uuid';

export type SequentialId = Tagged<string, 'SequentialId'>;

export namespace SequentialId {
  export const generate = (): SequentialId => {
    return uuidV7() as SequentialId;
  };
  export function FromString(id: string): SequentialId {
    // validate ex) 001931f3f-8ebf-788d-82dd-f2b633abafd6
    if (!validate(id)) throw new Error(`Invalid SequentialId: ${id}`);
    return id as SequentialId;
  }
}

export type UniqueId = Tagged<string, 'UniqueId'>;

export namespace UniqueId {
  export const generate = (): UniqueId => {
    return uuidV4() as UniqueId;
  };
  export function FromString(id: string): UniqueId {
    // validate ex) 001931f3f-8ebf-788d-82dd-f2b633abafd6
    if (!validate(id)) throw new Error(`Invalid UniqueId: ${id}`);
    return id as UniqueId;
  }
}

const IDに利用される文字 = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
const _generator = customAlphabet(IDに利用される文字);

export type UniqueShortId = Tagged<string, 'UniqueShortId'>;
export namespace UniqueShortId {
  /**
   * lengthについて
   * 8文字:  200万回の生成で衝突確率が1%
   * 10文字: 1.3億回の生成で衝突確率が1%
   * 12文字: 80億回の生成で衝突確率が1%
   * 14文字: 5000億回の生成で衝突確率が1%
   * 16文字: 1.2兆回の生成で衝突確率が1%
   * 21文字: 標準のnanoidの長さ (uuid v4相当)
   */
  export const GetFactory = (length: number) => {
    const generator = () => _generator(length);

    return {
      generate(): UniqueShortId {
        return generator() as UniqueShortId;
      },

      FromString(id: string): UniqueShortId {
        if (id.length !== length) throw new Error(`Invalid id: ${id}`);
        return id as UniqueShortId;
      },
    };
  };
}
